import type { z } from 'zod';

import { SCHOOL_TYPE_LABELS, SchoolType } from './enums';
import type { SchoolSchema } from './schemas';

type SchoolField = keyof z.infer<typeof SchoolSchema>;

export const SCHOOL_TYPES = Object.values(SchoolType).map(type => ({
  value: type,
  label: SCHOOL_TYPE_LABELS[type],
}));

const listAttributes = [
  'id',
  'label',
  'shortLabel',
  'abbreviation',
  'type',
  'hscRank',
  'address',
] as const satisfies readonly SchoolField[];

const searchAttributes = [
  'label',
  'shortLabel',
  'abbreviation',
] as const satisfies readonly SchoolField[];

const updateAttributes = [
  'label',
  'shortLabel',
  'abbreviation',
  'type',
  'hscRank',
  'address',
] as const satisfies readonly SchoolField[];

// Optional attributes that an update may unset by sending null
const removableAttributes = ['abbreviation', 'hscRank'] as const satisfies readonly SchoolField[];

export const SchoolAttributes = {
  List: listAttributes,
  Get: listAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
  Removable: removableAttributes,
};
